<template>
  <span>
    <AppSelectCheckboxes
      v-if="showCheckboxesView()"
      v-model="discipline"
      :items="disciplinesPrepared"
      :label="label"
      :item-value="itemValue"
      v-bind="$attrs"
      use-item-color
      item-text="name"
      :data-test="dataTest"
    />
    <v-select
      v-else
      v-model="discipline"
      v-show-fade="{ isFilter: isFilter }"
      :items="disciplinesPrepared"
      :label="label"
      :class="[selectMixinClass]"
      v-bind="$attrs"
      :data-test="dataTest"
      :menu-props="menuProperties"
      :item-value="itemValue"
      item-text="name"
      :dense="dense"
      :clearable="clearable"
      :hide-details="isFilter || hideDetails || dense"
      outlined
      hide-no-data
      @change="inputVisibility($event, 'change')"
      @focus="focused"
      @blur="[inputVisibility, $emit('blur')]"
    />
  </span>
</template>

<script>
import { useDisciplineHelper } from "@composables/masterdata/competitions/disciplines";
import { MasterDisciplineFragment } from "@/composables/masterdata/competitions/disciplines";
import AppSelectCheckboxes from "./AppSelectCheckboxes.vue";
import selectMixin from "./selects_mixin";
export default {
  name: "AppSelectDiscipline",
  components: {
    AppSelectCheckboxes
  },
  mixins: [selectMixin],
  props: {
    value: {
      type: [Object, String, Array],
      default: null
    },
    possibleValues: {
      type: Array,
      default: () => []
    },
    excludeNames: {
      type: Array,
      default() {
        return [];
      }
    },
    excludeIds: {
      type: Array,
      default() {
        return [];
      }
    },
    excludeNonFei: {
      type: Boolean,
      default: false
    },
    showOnlyGivenIds: {
      type: Array,
      default: () => []
    },
    hideDetails: { type: Boolean, default: false },
    itemValue: {
      type: String,
      default: "id"
    },
    clearable: {
      type: Boolean,
      default: true
    },
    dense: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default() {
        return this.$t("common:element.select.disipline.label", "Discipline");
      }
    },
    includeDisabled: {
      type: Boolean,
      default: false
    },
    dataTest: {
      type: String,
      default: "disciplineId"
    }
  },
  setup() {
    return {
      ...useDisciplineHelper()
    };
  },
  data() {
    return {
      menuProperties: {}
    };
  },
  computed: {
    discipline: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    disciplinesPrepared() {
      const customDisciplineObject = d => {
        return {
          id: d.id,
          codename: d.codename,
          name: this.$t("common:discipline." + d.name),
          color: d.name, // Props for AppSelectCheckboxes
          value: d.name
        };
      };

      if (this.possibleValues.length > 0) {
        return this.masterDisciplines
          .filter(x => this.possibleValues.includes(x.id))
          .map(customDisciplineObject);
      }

      const disciplines = this.includeDisabled
        ? this.allMasterDisciplines
        : this.masterDisciplines;
      return disciplines.reduce((array, d) => {
        if (
          this.excludeNames.includes(d.name) ||
          this.excludeIds.includes(d.id) ||
          (this.showOnlyGivenIds.length &&
            !this.showOnlyGivenIds.includes(d.id)) ||
          (this.excludeNonFei &&
            ["icelandic", "western", "mountedgames"].includes(d.name))
        ) {
          return array; // Do not push it into array
        }
        array.push(customDisciplineObject(d));
        return array;
      }, []);
    }
  },
  created() {
    this.menuProperties.nudgeBottom = this.nudgeBottom;
  },
  fragments: {
    disciplineFields: MasterDisciplineFragment
  }
};
</script>
